import { useMemo } from "react";
import { GlobalStyles, ThemeProvider } from "@mui/material";
import { useColorMode } from "../../../contexts/ColorModeContext";
import { buildControladoriaMuiTheme } from "./theme";
import {
  DARK_CONTENT_VARS,
  LIGHT_CONTENT_VARS,
  buildLegacyContentOverrides,
} from "./contentTokens";
import { ControladoriaPageActionsProvider } from "./ControladoriaPageActionsContext";

/**
 * Provider do layout MUI da Controladoria.
 * Consome o ColorMode global e aplica o tema/tokens do módulo.
 */
const ControladoriaMuiProvider = ({ children }) => {
  const { mode } = useColorMode();

  const theme = useMemo(() => buildControladoriaMuiTheme(mode), [mode]);
  const contentVars = mode === "dark" ? DARK_CONTENT_VARS : LIGHT_CONTENT_VARS;
  const legacyOverrides = useMemo(
    () =>
      buildLegacyContentOverrides(mode, {
        rootSelector: '[data-ctrl-mui-mode="dark"]',
        contentSelector: ".ctrl-mui-content",
      }),
    [mode]
  );

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles
        styles={{
          "[data-ctrl-mui-mode]": contentVars,
          ...legacyOverrides,
        }}
      />
      <ControladoriaPageActionsProvider>{children}</ControladoriaPageActionsProvider>
    </ThemeProvider>
  );
};

export default ControladoriaMuiProvider;
